<div class="main-container">
    <div class="bar-title">
        <span>
            {{barChartTitle}}
        </span>
    </div>
    <div [hidden]="!chart">
        <canvas class="" id="canvas" width="900" height="600">{{chart}}</canvas>
    </div>

</div>